// extracted by mini-css-extract-plugin
export default {"container":"c3yWW","hovered":"rTKM3","dropzone":"yz6Id","player":"S6j9H"};